import { render, staticRenderFns } from "./MasonryGrid.vue?vue&type=template&id=b4b2d31a"
import script from "./MasonryGrid.vue?vue&type=script&lang=js"
export * from "./MasonryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports